//import liraries
import React, { useEffect, useState, useRef } from "react";
import {View, Text, Image, TouchableOpacity, FlatList, ScrollView, Linking, ActivityIndicator} from "react-native";
import CustomButton from "../../common/CustomButton";
import { getDigiLockerStatus, initiateVerification, panValidationV2, digilockerConfig,getFuelKycStatus, getFuelOtp, validateFuelOtp,} from "../../api/digiLockerApi";
import { getUserDetails} from "../../api/apiManager";
import { get, reverse } from "lodash";
import CustomInput from "../../common/CustomInput";
import ModalAlert from "../../common/ModalAlert";
import ModalAlertForTwoButtons from "../../common/ModalAlertForTwoButtons";
import Loader from "../../common/Loader";
import CountdownTimer from "../../common/CTimer.web";
import useStyles from "./FuelRecharge_Styles";
import CImage from "../../common/CImage";
import CText from "../../common/CText";

// create a component
const FuelRecharge = (props) => {
  let count = 0
  let interval = useRef();
  const [loading, setLoading] = useState(false);
  const [digilockerWaitingPeriod, setDigilockerWaitingPeriod] = useState(0);
  const [digilockerStatusRetryCount, setDigilockerStatusRetryCount] = useState(0);
  const [digilockerStatusCheckInterval, setDigilockerStatusCheckInterval] = useState(0);
  const [verificationData, setVerificationData] = useState({});
  const [panSubmit, setPanSubmit] = useState(false);
  const [switched, setSwitched] = useState(true);
  const [journeyId, setJourneyId] = useState(false);
  const [errModalVisible, setErrModalVisible] = useState(false);
  const [otpData, setOtpData] = useState("");
  const [mobileOtpMsg, setMobileOtpMsg] = useState("");
  const otpPattern = /^\d{6}$/;
  const panPattern = /(?=.*[A-Z])(?=.*\d)[A-Z\d^()]/
  const [userData, setUserData] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showPanValidation, setShowPanValidation] = useState(false);
  const [isDigitalKyc, setIsDigitalKyc] = useState(false);
  const [pan, setPan] = useState("");
  const [isInterval, setIsInterval] = useState(false);
  const [digilockerTimeData, setDigilockerTimeData] = useState({});
  const [otpModalVisible, setOtpModalVisible] = useState(false);
  const [otp, setOtp] = useState();
  const styles = useStyles();
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [alertModal, setAlertModal] = useState({ title: "", status: "", message: "", navigateScreen: "", actionButton: ""});
  const counterRef = useRef(null);
  const fuelTranData = [];

const getProfileDetails = () => {
    setLoading(true);
    getFuelKycStatus()
      .then(response => {
        console.log(response, 'getIsDigitalKyc')
       getUserDetails()
          .then(res => {
            console.log(res, 'getProfileDetails')
            setIsDigitalKyc(response?.response?.isDigitalKyc == "Y" || res?.kyc == "Min KYC" ? true : false)
            if (res.fuelFlag == "Y") { setSwitched(true) } else { setSwitched(false) }
            setUserData(res)
            setLoading(false);
          }).catch(() => { setLoading(false);});
      }).catch(() => { setLoading(false); });
  }

  useEffect(() => {
    getProfileDetails();
    getDigilockerTimeDuration()
    console.log("fuel screen test")
  }, []);

  const getDigilockerTimeDuration = () => {
    setLoading(true)
    digilockerConfig().then((res) => {
      setLoading(false)
      if (res.data) {
        setDigilockerTimeData(res.data)
        setDigilockerStatusCheckInterval(res.data.digilockerStatusCheckInterval * 1000)
        setDigilockerStatusRetryCount(res.data.digilockerStatusRetryCount)
        setDigilockerWaitingPeriod(res.data.digilockerWaitingPeriod * 1000)
      }
    }).catch(err => { })
  }

  const getOtp = () => {
    setLoading(true)
    getFuelOtp().then((res) => {
      if (res?.statusCode < 0 || res.statusCode == 500) {
        setAlertModal({ title: "Error", status: "error", message: res?.message, navigateScreen: "", actionButton: "OK",});
        setAlertModalVisible(true);
      } else {
        setOtpData(res?.response)
        setMobileOtpMsg(res?.message)
        setOtpModalVisible(true)
      }
    }).catch(err => { console.log(err, "err in get otp fuel") })
      .finally(() => setLoading(false))
  }

  const validateOtp = () => {
    setLoading(true)
    let params = {type: switched ? "fuelOptOut" : "fuelOptIn", otp: otp, otpTxnId: otpData?.otpTxnId, requestId: otpData?.requestId }
    if (journeyId) { params = { ...params, "journeyId": journeyId }}
    console.log(params)
    validateFuelOtp(params).then((res) => {
      setLoading(false)
      if (res?.statusCode < 0 || res.statusCode == 500) {
        setAlertModal({ title: "Error", status: "error", message: res?.message, navigateScreen: "", actionButton: "OK",});
        setAlertModalVisible(true);
        setOtpModalVisible(false)
        setOtp("")
      } else if (res?.statusCode == 200) {
        setAlertModal({ title: "Success", status: "success", message: res?.message, navigateScreen: "", actionButton: "OK",});
        setAlertModalVisible(true);
        setOtp("")
        setOtpModalVisible(false)
        if (res?.response?.fuelFlag == "Y") { setSwitched(true) } else {
          getProfileDetails()
          setSwitched(false)
        }}
    }).catch(err => { console.log(err, "err in get otp fuel") })
      .finally(() => setLoading(false))
  }

  const validatePan = () => {
    setShowPanValidation(false)
    setLoading(true)
    let params = {}
    if (pan) {  params = { panNumber: pan.toUpperCase() }}
    panValidationV2(params).then(res => {
      setLoading(false)
      if (res.statusCode < 0 || res.statusCode == 500 || res.statusCode == 796) {
        setAlertModal({ title: "Error", status: "error", message: res?.message, navigateScreen: "", actionButton: "OK",});
        setAlertModalVisible(true);
      }
      if (res.statusCode == 200) {
        setJourneyId(res?.data?.journeyId)
        setPanSubmit(true)
        setShowPanValidation(false)
      }
    }).catch(err => { })
  }

  const initiate_verification = () => {
    setShowPanValidation(false)
    setLoading(true)
    setPanSubmit(false)
    let param = { "mobileNo": userData?.mobileNo || "",}
    if (pan)
      param = { ...param, journeyId: journeyId }
    initiateVerification(param).then(res => {
      setLoading(false)
      if (res?.statusCode == 200) {
        setVerificationData(res?.data)
        console.log(res?.data, "verify data ")
        setShowLoader(true)
        setTimeout(() => {
          digiLockerStatus(res?.data)
          count = 0
          setIsInterval(true)
        }, [digilockerWaitingPeriod])
      } else if (res?.statusCode < 0 || res?.statusCode == 500) {
        setAlertModal({ title: "Error", status: "error", message: res?.message, navigateScreen: "", actionButton: "OK",});
        setAlertModalVisible(true);
      }
    }).catch(err => { })
  }

  useEffect(() => { console.log("verify data test", verificationData)}, [verificationData])

  const digiLockerStatus = (data = {}) => {
    let params = {stateCode: data?.stateCode || verificationData?.stateCode, journeyId: data?.journeyId || verificationData?.journeyId }
    console.log(params, "params")
    getDigiLockerStatus(params).then((res) => {
      console.log(res)
      if (res?.statusCode < 0 || res?.statusCode == 500) {
        setAlertModal({ title: "Error", status: "error", message: res?.message, navigateScreen: "", actionButton: "OK"});
        setAlertModalVisible(true);
        setShowLoader(false)
        setIsInterval(false)
      } else if (res?.statusCode == 200) {
        setAlertModal({ title: "Success", status: "success", message: res.message, navigateScreen: "", actionButton: "OK"});
        setAlertModalVisible(true);
        setShowLoader(false)
        setIsInterval(false)
        getOtp()
      } else if (res?.statusCode == 1060) { }
    }).catch(err => console.log(err))
  }

  useEffect(() => {
    if (isInterval) {
      console.log("isterval true")
      interval.current = setInterval(() => {
        if (count < digilockerStatusRetryCount) {
          digiLockerStatus()
          count++
          if (!isInterval) {
            console.log(count, "count+++")
            return clearInterval(interval.current)
          }
        } else if (count => digilockerStatusRetryCount) {
          clearInterval(interval.current)
          setShowLoader(false)
          setAlertModal({ title: "Error", status: "error", message: "DigiLocker verification timeout", navigateScreen: "", actionButton: "OK"});
          setAlertModalVisible(true);
          setShowLoader(false)
        }
      }, [digilockerStatusCheckInterval])
    } else {
      clearInterval(interval.current)
      console.log("isterval false")
    }
  }, [isInterval])

  const onCloseModal = () => { setAlertModalVisible(false); setPan("")};
  
  return (
    <View style={styles.mainContainer}>
      <View style={styles.tabBannerStyle}>
        <TouchableOpacity style={[styles.tabBannerStyle]} onPress={() => Linking.openURL("https://digital.idfcfirstbank.com/apply/savings")}>
          <Image source={require("../../assets/images/fuelbanner_tab.png")} style={{ width: "100%", height: 100, resizeMode: "contain" }} />
        </TouchableOpacity>
      </View>
      <View style={styles.mobileBannerStyle}>
        <TouchableOpacity style={[styles.mobileBannerStyle]} onPress={() => Linking.openURL("https://digital.idfcfirstbank.com/apply/savings")}>
          <Image source={require("../../assets/images/fuelbanner_mobile1.png")} style={{ width: "100%", height: 123, resizeMode: "contain" }} />
        </TouchableOpacity>
      </View>
      <View style={styles.container}>
        <View style={styles.viewStyle} >
          <View>
            <Text style={styles.fuelPaymentTextStyle} > {"Fuel Payment Made Easy"} </Text>
            <Text style={styles.fuelStatusTextStyle}> {"Fuel payments can be quickly done via  \n IDFC FASTag"} </Text>
            <Text style={[styles.fuelStatusTextStyle, {paddingTop: 25}]} >{"Fuel Payment Status"}</Text>
            <TouchableOpacity style={[styles.toggleContainerStyle, { backgroundColor: switched ? "#00d54f" : "#eeeeee", }]} onPress={() => { isDigitalKyc ? getOtp() : switched ? getOtp() : initiate_verification()}}>
              <View style={styles.toggleViewStyle} >
                {!switched && ( <View style={styles.switchViewStyle} /> )}
                <Text style={[styles.activeTextStyle, {color: switched ? "#ffffff" : "#757575", paddingRight: switched ? 0 : 20,paddingLeft: switched ? 20 : 0,}]}> {switched ? "ACTIVE" : "INACTIVE"} </Text>
                {switched && (<View style={styles.switchViewStyle} /> )}
              </View>
            </TouchableOpacity>
            <Text style={[styles.fuelStatusTextStyle, { paddingTop: 5 }]} > {`Fuel payment is currently ${switched ? "" : "not"} activated`}</Text>
            <Text style={styles.fuelStatusTextStyle}> {`Toggle switch to  ${switched ? "inactivate" : "activate"}`} </Text>
          </View>
          <View style={styles.fuelIconStyle}> 
          <CImage.FuelIcon></CImage.FuelIcon> 
          </View>
        </View>
        <View style={styles.secondViewStyle}>
          <View style={{marginVertical: 20}}>
            <Text style={styles.recentTransTextStyle} > {"Recent Fuel Transactions"}</Text>
            <View style={styles.tableContainerStyle} >
              <ScrollView showsHorizontalScrollIndicator={false} horizontal={true}>
                <View style={{ width: "100%", borderRadius: 10 }}>
                  <View style={styles.headingViewStyle}>
                    <CText.tranxnText>{"TXN ID"}  </CText.tranxnText>
                    <CText.tranxnText>{"Date"}  </CText.tranxnText>
                    <CText.tranxnText>{"Vehicle No."}  </CText.tranxnText>
                    <CText.tranxnText>{"Amount"}  </CText.tranxnText>
                  </View>
                  <FlatList
                    showsVerticalScrollIndicator
                    data={fuelTranData}
                    showsHorizontalScrollIndicator
                    keyExtractor = {(item, index) => index+"_"+item?.id?.toString() }
                    key={(item, index) => item.id}
                    renderItem={({ item, index }) => {
                      return (
                        <View>
                          <View style={[styles.dataViewStyle,{backgroundColor:index % 2 !== 0 ? "#f2f4f5" : "#ececec"}]} >
                            <Text style={[ styles.dataTextStyle,{ width: 160, minWidth: 160 } ]}> {item.transId} </Text>
                            <Text style={[styles.dataTextStyle, { width: 150, minWidth: 150 }]}> {item.transDate} </Text>
                            <Text style={[styles.dataTextStyle,{ width: 150, minWidth: 150 }]}> {item.vrnNo} </Text>
                            <Text style={[styles.dataTextStyle,{ width: 160, minWidth: 160 }]}> {item.amount} </Text>
                          </View>
                        </View>
                      );
                    }}
                  />
                </View>
              </ScrollView>
            </View>
          </View>
        </View>

        {otpModalVisible ? (
          <View style={styles.overlayViewStyle}>
            <View style={styles.overlayContainer}>
              <View style={styles.overlay}>
                <View style={styles.overlayContentViewStyle}>
                  <Text style={styles.enterOtpTextStyle}>{"Enter OTP"}</Text>
                  <Text style={styles.otpDescTextStyle}> {mobileOtpMsg} </Text>
                  <View style={{ alignSelf: "center" }}>
                    <CustomInput
                      onValueChanged={(e) => setOtp(e)}
                      value={otp}
                      keyboardType="numeric"
                      pattern={/^\d{6}$/}
                      errorMessage={"Enter Valid OTP"}
                      maxLength={6}
                      style={[ styles.otpInputViewStyle,{ alignSelf: "center" } ]}
                    />
                  </View>
                  <View style={styles.resendViewStyle}>
                  <CountdownTimer
                  requestOtp={otpModalVisible}
                    onClickGetOtp={() =>{
                      let reqObj = {type: "updateProfile",flag: "1",id: get(userData, "userId", ""),};
                    getOtp(reqObj)
                    }}
                    counterRef={counterRef} />
                  </View>
                  <View style={styles.submitBtnWidget}>
                    <CustomButton text={"Submit"} onPress={() => {!otpPattern.test(otp) ? ()=>{} : validateOtp(); }} disable={!otpPattern.test(otp) ? true : false} />
                  </View>
                </View>
              </View>
            </View>
          </View>
        ) : null}
        {showPanValidation ? (
          <View style={styles.overlayViewStyle}>
            <View style={styles.overlayContainer}>
              <View style={styles.overlay}>
                <View style={styles.overlayContentViewStyle}>
                  <Text style={styles.enterOtpTextStyle}>{"Enter PAN"}</Text>
                  <Text style={styles.otpDescTextStyle}> {"Enter your PAN to continue"} </Text>
                  <View style={{ alignSelf: "center" }}>
                    <CustomInput
                      onValueChanged={(e) => setPan(e.toUpperCase())}
                      value={pan}
                      pattern={/(?=.*[A-Z])(?=.*\d)[A-Z\d^()]/}
                      errorMessage={"Enter Valid Pan"}
                      maxLength={10}
                      style={[styles.otpInputViewStyle,{ alignSelf: "center" }]}
                    />
                  </View>
                  <View style={styles.btnWrapper} >
                    <View style={styles.validateButtonViewStyle} >
                      <CustomButton text={"Validate"} onPress={() => {!panPattern.test(pan) ? ()=>{} : validatePan();}} disable={!panPattern.test(pan) ? true : false} fontSize={13} />
                    </View>
                    <View style={styles.withoutPanBtnWidget} >
                      <CustomButton text={"Continue without pan"} onPress={() => initiate_verification() } fontSize={13} />
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </View>
        ) : null}
        {panSubmit ? (
          <View style={styles.overlayViewStyle}>
            <View style={styles.overlayContainer}>
              <View style={styles.overlay}>
                <View style={styles.overlayContentViewStyle}>
                  <Text style={styles.enterOtpTextStyle}>{"Enter PAN"}</Text>
                  <Text style={styles.otpDescTextStyle}> {"Your PAN is verified, please submit to continue"}  </Text>
                  <View style={{ alignSelf: "center" }}>
                    <CustomInput value={pan} keyboardType="numeric" pattern={/(?=.*[A-Z])(?=.*\d)[A-Z\d^()]/} style={[ styles.otpInputViewStyle,{ alignSelf: "center" }]}/>
                  </View>
                  <View style={styles.submitBtnWidget}>
                    <CustomButton text={"Submit"} onPress={() => { initiate_verification()}} />
                  </View>
                </View>
              </View>
            </View>
          </View>
        ) : null}
        {alertModalVisible ? (
          <View style={styles.overlayViewStyle}>
            <ModalAlert title={alertModal.title} status={alertModal.status} message={alertModal.message} navigateScreen={alertModal.navigateScreen} actionButton={"OK"} onCloseModal={onCloseModal} />
          </View>) : null}
        {errModalVisible ? (
          <View style={styles.overlayViewStyle}>
            <ModalAlertForTwoButtons
              title={alertModal.title}
              status={alertModal.status}
              message={alertModal.message}
              navigateScreen={alertModal.navigateScreen}
              actionButton1={"Later"}
              actionButton2={"Apply Now"}
              onPressActionButton1={() => { setErrModalVisible(false)}}
              onPressActionButton2={() => {
                setErrModalVisible(false);
                Linking.openURL(global?.AUTO_RECHARGE_APPLY_LINK)
              }}
              backgroundColor={"#bd2d37"}
              color={"#ffffff"}
            />
          </View> ) : null}
        {showLoader ? <View style={styles.containerLoader}>
          <View style={styles.spinnerBox}>
            <ActivityIndicator size={props.size ? props.size : "large"} color="#707070" style={styles.spinner} />
            <CText.smsText> {"SMS has been sent to mobile number"}</CText.smsText>
            <CText.smsText> {"Please complete the digiLocker verification."}</CText.smsText>
          </View>
        </View> : null}
        {loading && <Loader />}
      </View>
      <View style={[styles.bannerStyle, {}]}>
        <TouchableOpacity style={[styles.bannerStyle, {}]} onPress={() => Linking.openURL("https://digital.idfcfirstbank.com/apply/savings")}>
          <CImage.FuelBanner></CImage.FuelBanner>
        </TouchableOpacity>
      </View>
    </View>
  );
};

//make this component available to the app
export default FuelRecharge;
